import React from 'react'
import Layout from './layout/layout'

function App() {
  return (
    <div>
      <Layout />
    </div>
  )
}

export default App